import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import BackIcon from '@fortawesome/fontawesome-free-solid/faLongArrowAltLeft'

import { Button2, CheckBox } from '../../../common'
import Input from '../../../common/Input'

import * as Strings from './strings'
import * as Constants from '../../../../helpers/Constants'
import * as userActions from '../../../../actions/User'
import * as configActions from '../../../../actions/Config'

class GetStarted extends Component {
  constructor(props) {
    super(props)
    this.state = {
      nameInput: '',
      emailInput: '',
      passwordInput: '',
      phoneInput: '',
      emailError: '',
      privileges: {
        laundryBookingSystem: true,
        bookingSystem: true,
        errorReportSystem: true,
        feedSystem: true,
        infoSystem: true
      },
      width: window.innerWidth,
      step: 1
    }

    this.resizeHandler = this.resizeHandler.bind(this)
  }

  componentWillMount() {
    window.addEventListener('resize', this.resizeHandler)
  }

  componentWillReceiveProps(nextProps) {
    const { history } = this.props
    const { user, data } = nextProps

    if (user.fetched && !this.props.user.fetched) {
      if (data.privileges.laundryBookingSystem) {
        history.push('/laundrybookings')
      } else if (data.privileges.bookingSystem) {
        history.push('/bookingsystems')
      } else if (data.privileges.errorReportSystem) {
        history.push('/newerrorreport')
      } else if (data.privileges.feedSystem) {
        history.push('/news')
      } else if (data.privileges.infoSystem) {
        history.push('/communityinformation')
      } else {
        history.push('/mypage')
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler)
  }

  resizeHandler() {
    this.setState({ width: window.innerWidth })
  }

  create() {
    const { config } = this.props
    const {
      privileges,
      nameInput,
      emailInput,
      passwordInput,
      phoneInput
    } = this.state

    let onePrivilegeSelected = false

    Object.keys(privileges).forEach(key => {
      if (privileges[key]) {
        onePrivilegeSelected = true
      }
    })

    if (!onePrivilegeSelected) {
      this.props.showAlert(
        Strings.default.CHOSE_ATLEAST_ONE_SYSTEM[config.language],
        Strings.default.CHOSE_ATLEAST_ONE_SYSTEM_INFO[config.language],
        Constants.ONE_BUTTON,
        { title: Strings.default.OK[config.language], onPress: () => {} }
      )
    } else {
      const postData = {
        corporation: {
          name: nameInput,
          email: emailInput,
          phoneNumber: phoneInput,
          address: '',
          zipCode: '',
          firstName: '',
          lastName: '',
          price: '',
          city: '',
          orgNumber: ''
        },
        community: {
          name: nameInput,
          appartments: 0,
          emailAddress: emailInput,
          phoneNumber: phoneInput,
          address: '',
          postalNumber: '',
          confirmed: true,
          firstName: '',
          lastName: '',
          campaignCode: '',
          price: '',
          city: '',
          orgNumber: '',
          laundrySetupDone: true
        },
        user: {
          email: emailInput,
          appartment: 'lägenhetsnummer',
          password: passwordInput
        },
        laundryRules: {
          maxBookings: 2,
          bookingRange: 8,
          laundryType: 'S'
        },
        privileges
      }

      this.props.tryCreateCorporation(postData, config.language, (h, i, t, b) =>
        this.props.showAlert(h, i, t, b)
      )
    }
  }

  toStep2() {
    const { config } = this.props
    const { nameInput, emailInput, passwordInput, phoneInput } = this.state

    if (
      nameInput === '' ||
      emailInput === '' ||
      passwordInput === '' ||
      phoneInput === ''
    ) {
      this.props.showAlert(
        Strings.default.MANDATORY_FIELDS[config.language],
        Strings.default.MANDATORY_FIELDS_INFO[config.language],
        Constants.ONE_BUTTON,
        { title: Strings.default.OK[config.language], onPress: () => {} }
      )
    } else {
      const postData = { email: emailInput }

      this.props.validateEmailIsUnique(
        postData,
        () => this.setState({ step: 2 }),
        () =>
          this.setState({
            emailError: Strings.default.EMAIL_TAKEN[config.language]
          }),
        config.language,
        (h, i, t, b) => this.props.showAlert(h, i, t, b)
      )
    }
  }

  renderContent() {
    const {
      passwordInput,
      emailInput,
      nameInput,
      phoneInput,
      step,
      privileges,
      emailError
    } = this.state
    const { config, user } = this.props

    if (step === 1) {
      return (
        <div>
          <Input
            placeholder={Strings.default.ASSOCIATION_NAME[config.language]}
            value={nameInput}
            onChange={value => this.setState({ nameInput: value })}
          />
          <Input
            placeholder={Strings.default.PHONE_NUMBER[config.language]}
            value={phoneInput}
            onChange={value => this.setState({ phoneInput: value })}
          />
          <Input
            placeholder={Strings.default.EMAIL[config.language]}
            value={emailInput}
            onChange={value =>
              this.setState({ emailInput: value, emailError: '' })
            }
            error={emailError}
          />
          <Input
            placeholder={Strings.default.PASSWORD[config.language]}
            value={passwordInput}
            type={'password'}
            onChange={value => this.setState({ passwordInput: value })}
          />
          <Button2
            onClick={() => this.toStep2()}
            header={Strings.default.NEXT[config.language]}
            loading={user.isValidatingEmail}
          />
        </div>
      )
    }

    return (
      <div>
        <p>{Strings.default.WHAT_SYSTEMS_TO_ACTIVATE[config.language]}</p>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <CheckBox
            label={Strings.default.LAUNDRY_BOOKING_SYSTEM[config.language]}
            checked={privileges.laundryBookingSystem}
            onClick={() =>
              this.setState({
                privileges: {
                  ...privileges,
                  laundryBookingSystem: !privileges.laundryBookingSystem
                }
              })
            }
          />
          <CheckBox
            label={Strings.default.OTHER_BOOKING_SYSTEM[config.language]}
            checked={privileges.bookingSystem}
            onClick={() =>
              this.setState({
                privileges: {
                  ...privileges,
                  bookingSystem: !privileges.bookingSystem
                }
              })
            }
          />
          <CheckBox
            label={Strings.default.ERROR_REPORT_SYSTEM[config.language]}
            checked={privileges.errorReportSystem}
            onClick={() =>
              this.setState({
                privileges: {
                  ...privileges,
                  errorReportSystem: !privileges.errorReportSystem
                }
              })
            }
          />
          <CheckBox
            label={Strings.default.NEWS_FEED[config.language]}
            checked={privileges.feedSystem}
            onClick={() =>
              this.setState({
                privileges: {
                  ...privileges,
                  feedSystem: !privileges.feedSystem
                }
              })
            }
          />
          <CheckBox
            label={Strings.default.INFO_VIEW[config.language]}
            checked={privileges.infoSystem}
            onClick={() =>
              this.setState({
                privileges: {
                  ...privileges,
                  infoSystem: !privileges.infoSystem
                }
              })
            }
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button2
            onClick={() => this.setState({ step: 1 })}
            header={Strings.default.BACK[config.language]}
            disabled={user.isFetching || user.isCreatingCorporation}
            style={{ width: '45%' }}
            className={'warning_button'}
          />
          <Button2
            onClick={() => this.create()}
            header={Strings.default.GET_STARTED[config.language]}
            loading={user.isFetching || user.isCreatingCorporation}
            style={{ width: '45%' }}
          />
        </div>
      </div>
    )
  }

  render() {
    const { width, step } = this.state
    const { config } = this.props

    return (
      <div className={'basicCentered'}>
        <div className={'basicContainer'}>
          <h5>
            {Strings.default.GET_STARTED[config.language] + ' (' + step + '/2)'}
          </h5>
          <p>{Strings.default.GET_STARTED_INFO[config.language]}</p>
          {this.renderContent()}
        </div>
      </div>
    )
  }
}

function mapStateToProps({ user, config, data }) {
  return { user, config, data }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...userActions, ...configActions }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(GetStarted)



// WEBPACK FOOTER //
// ./src/components/pages/preLogin/GetStarted/index.js